module.exports = __webpack_public_path__ + "static/img/60.1985756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/60.png
// module id = N51c
// module chunks = 73